import styled from 'styled-components';

export const ChildrenContainer = styled.div<{ cardView?: boolean }>`
  border-radius: 10px;
  border: ${({ theme, cardView }) => (cardView ? `1px solid ${String(theme.colors.grey[90])}` : `none`)};
  height: ${(props) => (props.cardView ? `auto` : '100%')};
  overflow: hidden;
  padding: ${(props) => (props.cardView ? `16px` : '0')};
  transform: translateZ(0px);
  width: 100%;
`;
